// 关于我们
const aboutUsList = {
  path: '/about/aboutJp',
  cname: '关于我们',
  name: 'aboutJp',
  il8nName: 'navs.aboutUsJp',
  children: [
    {
      path: '/about/introduce',
      cname: '公司介绍',
      name: 'aboutUs',
      il8nName: 'modules.intro.menu.introduce',
    },
    {
      path: '/about/course',
      cname: '企业沿革',
      name: 'course',
      il8nName: 'modules.intro.menu.course_jp',
    },
    {
      path: '/about/culture',
      cname: '顺丰企业文化',
      name: 'culture',
      il8nName: 'modules.intro.menu.culture_jp',
    },
    {
      path: '/about/topInterview',
      cname: '日本区总寄语',
      name: 'interview',
      il8nName: 'modules.intro.menu.finalWords_jp',
    },
    {
      path: '/about/address',
      cname: '公司地址',
      name: 'address',
      il8nName: 'modules.intro.menu.servicePoint',
    },
    {
      path: '/about/careers',
      cname: '人才招聘',
      name: 'careers',
      il8nName: 'modules.about.careers',
    },
    // {
    //   path: '/support/querySupport/auth_reseller',
    //   cname: '授权合作伙伴服务点',
    //   name: 'authReseller',
    //   il8nName: 'navs.authReseller',
    // },
    // {
    //   path: '/consulting/queryDescription',
    //   cname: '查询说明',
    //   name: 'consulting-queryDescription',
    //   il8nName: 'modules.about.queryDescription',
    // },
    //     {
    //   path: '',
    //   cname: '咨询中心',
    //   name: 'consulting',
    //   il8nName: 'modules.about.consulting',
    //   children: [
    //     {
    //       path: '/consulting/queryDescription',
    //       cname: '查询说明',
    //       name: 'consulting-queryDescription',
    //       il8nName: 'modules.about.queryDescription',
    //     },
    //   ],
    // },
  ],
}

export default aboutUsList
